import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyCreditProvider = subCompanyId =>
  createSelector(
    selectSubCompany,
    subCompany => subCompany?.creditProvider?.[subCompanyId] ?? null,
  );
